export const buildOutOfStockNotificationUrl = (
    baseUrl: string | undefined,
    itemId: string | undefined,
    param1: string | undefined,
    param2: string | undefined
): string | undefined => {
    if (!baseUrl || !itemId) {
        return undefined;
    }

    let url = baseUrl.trim();
    const params = new URLSearchParams();

    if (param1?.trim()) {
        params.append(param1.trim(), itemId);
    }
    if (param2?.trim()) {
        params.append(param2.trim(), itemId);
    }

    if (params.toString()) {
        url += (url.includes('?') ? '&' : '?') + params.toString();
    }

    return url;
};
